import React from 'react';
import WeightSlider from './WeightSlider';

const WeightInput = ({
    name,
    sliderColor,
    setWeight,
    id,
    index,
    obj,
    changeMade,
    readOnly
}) => {
    const weightChange = (e) => {
        obj.changed = true;
        setWeight(obj);
        if (!readOnly) changeMade();
    };
    const percentageChange = (e) => {
        let newPct = parseInt(e.target.value);
        if (!newPct || newPct < 0) {
            newPct = 0;
        }

        if (newPct > Math.round(obj.basePercentage) * 2) {
            obj.percentage = obj.basePercentage * 2;
            newPct = obj.percentage;
        }

        obj.changed = true;
        obj.percentage = newPct;
        obj.weight = (obj.percentage / obj.basePercentage) * 100;

        setWeight(obj);
        if (!readOnly) changeMade();
    };

    return (
        <div
            style={{ display: 'flex' }}
            className='weightInput'
            index={index}
            id={id}
            weight={obj.weight}
            percentage={obj.percentage}
            baseweight={obj.baseWeight}
            basepercentage={obj.basePercentage}
        >
            <span style={{ width: 200, fontSize: 15 }}>{name}</span>
            <div>
                <input
                    style={{
                        width: 47,
                        height: 30,
                        marginTop: 5,
                        borderRadius: 5,
                        border: '1px solid rgb(215,215,215)',
                        backgroundColor: readOnly
                            ? '#F7F7F7'
                            : 'rgb(255,253,244)',
                        marginRight: 23,
                        paddingRight: 10,
                        textAlign: 'right'
                    }}
                    basevalue={obj.basePercentage}
                    value={Math.round(obj.percentage)}
                    onChange={percentageChange}
                    disabled={readOnly}
                ></input>
            </div>

            <WeightSlider
                sliderColor={sliderColor}
                obj={obj}
                weightChange={weightChange}
                id={id}
                index={index}
                changeMade={changeMade}
                readOnly={readOnly}
            ></WeightSlider>
        </div>
    );
};
export default WeightInput;
